// import { ApacDetailModule } from './apac-detail.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListComponent } from './list/list.component';
import { DetailComponent } from './detail/detail.component';
import { ApacDetailService } from './apac-detail.service';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { RouterModule } from '@angular/router';
import { NgxLoadingModule } from 'ngx-loading';
import { ButtonsModule } from 'ngx-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ButtonsModule.forRoot(),
    NgxLoadingModule.forRoot({})
  ],
  declarations: [ListComponent, DetailComponent]
})
export class ApacDetailModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ApacDetailModule,
      providers: [
        ApacDetailService
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/apac-detail/apac-detail.module.ts